import React from 'react';

const NoEditionMessage = () => {
  return (
    <div className="match-partite-container">
      <div className="match-partite-header">
        <h2>Gestione Partite</h2>
      </div>
      <div className="no-edition-message">
        <i className="fas fa-info-circle"></i>
        <h3>Nessuna edizione selezionata</h3>
        <p>Seleziona un'edizione dalla pagina Tornei per gestire le partite.</p>
      </div>
    </div>
  );
};

export default NoEditionMessage;